import { ManageCookiesButton } from 'govbr.lgpd.plugin/components';
import { defineMessages, injectIntl } from 'react-intl';

import { BrDropdown } from '../layout';

const messages = defineMessages({
  quickAccess: { id: 'Quick access', defaultMessage: 'Quick access' },
  governmentAgencies: {
    id: 'Government Agencies',
    defaultMessage: 'Government Agencies',
  },
  accessToInformation: {
    id: 'Access to Information',
    defaultMessage: 'Access to Information',
  },
  legislation: { id: 'Legislation', defaultMessage: 'Legislation' },
  accessibility: { id: 'Accessibility', defaultMessage: 'Accessibility' },
  resetCookies: {
    id: 'Reset Cookies',
    defaultMessage: 'Reset Cookies',
  },
  highContrastTheme: {
    id: 'Hight contrast theme',
    defaultMessage: 'Hight contrast theme',
  },
});

const HeaderLinks = ({ intl }) => {
  // Lista de links do cabeçalho
  const headerLinks = [
    {
      title: intl.formatMessage(messages.governmentAgencies),
      url: 'https://www.gov.br/pt-br/orgaos-do-governo',
    },

    {
      title: intl.formatMessage(messages.accessToInformation),
      url: 'https://www.gov.br/acessoainformacao/pt-br',
    },
    {
      title: intl.formatMessage(messages.legislation),
      url: 'http://www4.planalto.gov.br/legislacao',
    },
    {
      title: intl.formatMessage(messages.accessibility),
      url: 'https://www.gov.br/governodigital/pt-br/acessibilidade-digital',
    },
  ];

  return (
    <>
      <BrDropdown
        className="header-links"
        iconToHide="fa-solid fa-ellipsis-vertical"
        iconToShow="fa-solid fa-ellipsis-vertical"
        label={intl.formatMessage(messages.quickAccess)}
        useIcons
      >
        <div className="br-list">
          <div className="header">
            <div className="title">
              {intl.formatMessage(messages.quickAccess)}
            </div>
          </div>

          {headerLinks.map((link) => (
            <a className="br-item" href={link.url} key={link.url}>
              {link.title}
            </a>
          ))}
        </div>
      </BrDropdown>
      <span className="br-divider vertical mx-half mx-sm-1"></span>
      <ManageCookiesButton
        className="br-button small circle"
        label-hidden
        label={intl.formatMessage(messages.resetCookies)}
      />
      <button
        className="br-button circle small"
        type="button"
        aria-label={intl.formatMessage(messages.highContrastTheme)}
        title={intl.formatMessage(messages.highContrastTheme)}
      >
        <i className="fa-solid fa-circle-half-stroke" aria-hidden="true"></i>
      </button>
    </>
  );
};

export default injectIntl(HeaderLinks);
